import * as Sentry from '@sentry/browser'
import React from 'react'
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'

import Fallback from './Fallback'

const isDev = /localhost/.test(window.location.href)

type TErrorBoundary = {
  children: React.ReactNode
}

type TComponentStack = {
  componentStack: string
}

function errorHandler(error: Error, componentStack: TComponentStack): void {
  console.error('errorHandler', error)
  if (isDev) {
    return
  }
  try {
    Sentry.withScope((scope) => {
      scope.setExtra('componentStack', componentStack)
      Sentry.captureException(error)
    })
  } catch (error) {
    console.error('Sentry is not initialized', { error, Sentry })
  }
}

const ErrorBoundary = (props: TErrorBoundary): React.ReactElement => {
  const { children } = props
  return (
    <ReactErrorBoundary onError={errorHandler} FallbackComponent={Fallback}>
      {children}
    </ReactErrorBoundary>
  )
}

export default ErrorBoundary
